

















import { defineComponent, useContext } from '@nuxtjs/composition-api';

export default defineComponent({
  setup() {
    const { i18n } = useContext();
    const EVALUATION_LIST = [
      {
        code: 'WA',
        title: i18n.t('Item-03.evaluation.WA.title').toString(),
        text: i18n.t('Item-03.evaluation.WA.body').toString(),
      },
      {
        code: 'WS',
        title: i18n.t('Item-03.evaluation.WS.title').toString(),
        text: i18n.t('Item-03.evaluation.WS.body').toString(),
      },
      {
        code: 'WE',
        title: i18n.t('Item-03.evaluation.WE.title').toString(),
        text: i18n.t('Item-03.evaluation.WE.body').toString(),
      },
      {
        code: 'JS',
        title: i18n.t('Item-03.evaluation.JS.title').toString(),
        text: i18n.t('Item-03.evaluation.JS.body').toString(),
      },
      {
        code: 'D',
        title: i18n.t('Item-03.evaluation.D.title').toString(),
        text: i18n.t('Item-03.evaluation.D.body').toString(),
      },
      {
        code: 'V',
        title: i18n.t('Item-03.evaluation.V.title').toString(),
        text: i18n.t('Item-03.evaluation.V.body').toString(),
      },
      {
        code: 'GR',
        title: i18n.t('Item-03.evaluation.GR.title').toString(),
        text: i18n.t('Item-03.evaluation.GR.body').toString(),
      },
    ];

    return {
      EVALUATION_LIST,
    };
  },
});
